<mat-card appearance="outlined">
  <mat-card-title><h2>Outstanding Charges</h2></mat-card-title>
  <mat-card-content>
    <ng-container>
      <div>
        <table id="collectPayment-table-outStandingCharges" mat-table [dataSource]="chargeDataSource" multiTemplateDataRows class="mat-elevation-z8">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              ></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let reservationCharge">
              <mat-checkbox
                id="collectPayment-checkBox-selectPayment-{{ reservationCharge.reservationDetail.id }}"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(reservationCharge) : null"
                [checked]="selection.isSelected(reservationCharge)"
              ></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let reservationCharge">{{ reservationCharge.amount | currency }}</td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let reservationCharge">{{ reservationCharge.createdDate | date: 'short' }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let reservationCharge">{{ reservationCharge.payment.paymentStatus.name }}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th class="description-header" mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let reservationCharge">{{ reservationCharge.description }}</td>
          </ng-container>

          <ng-container matColumnDef="reservation">
            <th mat-header-cell *matHeaderCellDef>Reservation</th>
            <td mat-cell *matCellDef="let reservationCharge">
              {{ reservationCharge.reservationDetail.id }}
              <i id="collectPayment-button-reservationDetails-{{ reservationCharge.reservationDetail.id }}" class="material-icons launch"
                 (click)="handleGoToReservation(reservationCharge.reservationDetail.id)">launch</i>
              <span class="expand">
                <mat-icon
                  id="collectPayment-button-expand-{{reservationCharge.reservationDetail.id}}"
                  class="expand_more"
                  (click)="handleExpandMore(reservationCharge)"
                  [@indicatorRotate]="reservationCharge == expandedReservationCharge ? 'open' : 'closed'"
                >
                  expand_more
                </mat-icon>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="paymentDetails">
            <td mat-cell *matCellDef="let reservationCharge" [attr.colspan]="displayedChargedColumns.length">
              <div class="payment-detail" [@detailExpand]="reservationCharge == expandedReservationCharge ? 'expanded' : 'collapsed'">
                <span
                ><small>Card:</small>
                  <span id="collectPayment-text-outstandingChargeCardDetails-{{ reservationCharge.payment.id }}">
                    {{ reservationCharge.payment.paymentAccount.cardType.name }} ending in
                    {{ reservationCharge.payment.paymentAccount.cardNumber }} &nbsp; [{{ reservationCharge.payment.paymentAccount.cardExpiration }}]
                  </span>
                </span>

                <button id="collectPayment-button-edit-{{ reservationCharge.payment.id }}" mat-stroked-button color="primary"
                        (click)="handleEditPaymentAccount(reservationCharge.payment.paymentAccount)">
                  Edit
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedChargedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedChargedColumns"
            class="payment-row"
            [class.payment-expanded-row]="expandedReservationCharge === row"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: ['paymentDetails']" class="payment-detail-row"></tr>
        </table>
      </div>
    </ng-container>
    <br/>
    <div>
      Total amount: <strong>{{ getTotal() | currency }}</strong>
    </div>

    <app-payment-account-selector [(ngModel)]="selectedPaymentAccount" [paymentAccounts]="paymentAccounts"></app-payment-account-selector>
  </mat-card-content>

  <mat-card-actions align="start">
    <button
      id="collectPayment-button-makePayment"
      [disabled]="!(selectedPaymentAccount && selection.selected.length > 0)"
      (click)="submit()"
      mat-raised-button
      *appRequiresPermissions="{ any: ['payment_processing'] }"
      color="primary"
    >
      Make Payment
    </button>
  </mat-card-actions>
</mat-card>
